export interface TimeSeries {
  timeStamp: number;
  value: string;
  color: string | null;
}

export interface SensorData {
  type: string;
  unit: string | null;
  timeSeries: TimeSeries[];
}

export interface BmsDetails {
  data: SensorData[];
  sensorName: string;
  description: string;
  identifier: string;
  sensorType: string;
  spaceName: string;
  typeWorkset?: string;
}
